import React, { useEffect, useState, useMemo} from 'react'
import api from '../components/api';
import { dataTableRender, rotulo, rotuloEnviado, sleep, cor, corEnviado, corCertificado } from '../components/functions'
import { useHistory } from 'react-router-dom'
//import { MDBDataTableV5 } from 'mdbreact';
import LoaderIcon from "react-loader-icon";

import ModalResiduo from '../modals/residuo'
import ModalValidacao from '../modals/validacao'
import ModalEmailCorrecao from '../modals/emailCorrecao'

import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { useVerificaDesafioContext } from '../context/verificaDesafioContext'

import ModalEmailVer from '../modals/emailVer'
import { useEmailVerContext } from '../context/emailVerContext'


import "@fortawesome/fontawesome-free/css/all.min.css";
import Badge from 'react-bootstrap/Badge';


const Residuos = () => {


    const history = useHistory()

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()
    const { desafioEmail_id, setDesafioEmail_id } = useEmailVerContext()
    
    const [carregando, setCarregando] = useState('block')
    var [residuo_id, setResiduo_id] = useState()
    var [adesao_institucional_id, setAdesaoInstitucionalId] = useState()

    var [resultado, setResultado] = useState([])
    var [resultadoPend, setResultadoPend] = useState([])
    var [resultadoRede, setResultadoRede] = useState()
    
    var [ano, setAno] = useState(new Date().getFullYear() -1)
    var [anos, setAnos] = useState()
    var [anoProps, setAnoProps] = useState()
    
    var [resultadoCorrecoes, setResultadoCorrecoes] = useState([])
    var [totalCorrecoes, setTotalCorrecoes] = useState(0)
    var [totalPreenchimentos, setTotalPreenchimentos] = useState(0)
    
    var [adesao_institucional_id_ref, setAdesaoInstitucionalIdRef] = useState(0)
    const [totalAdesoes, setTotalAdesoes] = useState(0)


    const [uf, setUF] = useState('')
    const [resultadoUF, setResultadoUF] = useState([])
    const [regiao, setRegiao] = useState('')
    const [resultadoRegiao, setResultadoRegiao] = useState([])

    const [totalVerificados, setTotalVerificados] = useState(0)
    const [resultadoVerificados, setResultadoVerificados] = useState([])


    /*
     <table id="dataTableExample4" className="table table-bordered table-striped table-hover">
            <thead>
                <tr>
                    <th>Nome Fantasia</th>
                    <th><center>CNPJ</center></th>
                    <th><center>Último preenchimento</center></th>
                    <th><center>Data último preenchimento</center></th>
                    <th><center>Adesão em</center></th>
                    
                    
                </tr>
            </thead>
            <tbody>
                {resultado}
            </tbody>
            
        </table>
        */


    const columnsR = useMemo(
    () => [
        {
        accessorKey: 'nome_fantasia', //access nested data with dot notation
        header: 'Nome Fantasia',
        },
        {
        accessorKey: 'cnpj',
        header: 'CNPJ',
        },
        {
        accessorKey: 'ultimoAnoInformado',
        header: 'Último preenchimento',
        },

        {
        accessorKey: 'ultimoEnvio',
        header: 'Data último preenchimento',
        },

        {
        accessorKey: 'dataAdesao',
        header: 'Adesão em',
        },
        
        

    ],
    [],
    );


    const columns = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoDesafio',
            header: 'Ano',
          },

          {
            accessorKey: 'uf_codigo',
            header: 'UF',
          },

          {
            accessorKey: 'situacaoPerfilAnual',
            header: 'Perfil Anual',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },

          {
            accessorKey: 'secaoGestao',
            header: 'Dados Gestão',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },

          {
            accessorKey: 'secaoGeracao',
            header: 'Dados Geração',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },

          {
            accessorKey: 'dataUltimoPreenchimento',
            header: 'Último preenchimento',
          },

          {
            accessorKey: 'dataAdesao',
            header: 'Adesão',
          },

          {
            accessorKey: 'situacaoEnviado',
            header: 'Situação',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'A' ? 'warning' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : renderedCellValue == null || renderedCellValue == 'P' ? 'primary' : 'warning' }`}>{rotuloEnviado(renderedCellValue)}</span>
                //<Badge style={{  backgroundColor: renderedCellValue == 'Z' ? '#c769c7' : renderedCellValue == 'P' ? '#ffc4ab' : renderedCellValue == 'S' || renderedCellValue == null  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#003366'  }}>{rotuloEnviado(renderedCellValue)}</Badge>
                <Badge style={{  backgroundColor: corEnviado(renderedCellValue) }}>{rotuloEnviado(renderedCellValue)}</Badge>
                
           
            ),
          },


          {
            accessorKey: 'dataEnvio',
            header: 'Enviado em',
          },


          {
            accessorKey: 'dataHoraUltimaAuditoria',
            header: 'Última auditoria em',
          },
         


         
         

        ],
        [],
      );





    const columnsCorrecoes = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoDesafio',
            header: 'Ano',
          },

          {
            accessorKey: 'situacaoPerfilAnual',
            header: 'Perfil Anual',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : '' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },

          {
            accessorKey: 'secaoGestao',
            header: 'Dados Gestão',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },

          {
            accessorKey: 'secaoGeracao',
            header: 'Dados Geração',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
           
            ),
          },
          {
            accessorKey: 'situacaoEnviado',
            header: 'Situação',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'A' ? 'warning' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotuloEnviado(renderedCellValue)}</span>
                //<Badge style={{  backgroundColor: renderedCellValue == 'P' ? '#ffc4ab' : renderedCellValue == 'S' || renderedCellValue == null  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#003366'  }}>{rotuloEnviado(renderedCellValue)}</Badge>
                <Badge style={{  backgroundColor: corEnviado(renderedCellValue) }}>{rotuloEnviado(renderedCellValue)}</Badge>
           
            ),
          },


        ],
        [],
      );



    async function carregaRede() {

        await api.get(`adesaoInstitucionalRede`).then((result) => {

            setResultadoRede(result.data.map((rs) =>

                <option value={rs.adesao_institucional_id} key={rs.adesao_institucional_id}>{rs.razao_social}</option>
            
            ))

        })

    }


    async function residuosLista() {

        await api.get('residuosLista').then((result) => {
            
            setTotalAdesoes(result.data.length)
            setResultado(result.data)

            /*
            setResultado(result.data.map((rs) => 

                <tr style={{ cursor: 'pointer'}} onClick={() => history.push(`ResiduosSS/${rs.adesao_institucional_id}`)}>
                    <td>
                        {rs.nome_fantasia}
                    </td>
                    <td>
                        <center>{rs.cnpj}</center>
                    </td>
                    
                    <td>
                        <center>
                        {rs.ultimoAnoInformado}
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.ultimoEnvio}
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.dataAdesao}
                        </center>
                    </td>
                </tr>

            ))

            dataTableRender('dataTableExample4', 0, 'asc')
            */
    


        }).catch((err) => {
            console.log(err.response)
        })

    }





    async function carregaAnos() {

        var anoTemp = []

        var anoAtual = new Date().getFullYear()

        for (var x = anoAtual; x >= 2008; x--) {

            var anoJson = {

                ano: x,

            }

            anoTemp.push(anoJson)

        }

        setAnos(anoTemp.map((rs) =>
        
            <option value={rs.ano}>{rs.ano}</option>
        
        ))

    }




    async function preenchimentos(adesao_institucional_id_ref) {

        if (adesao_institucional_id_ref == null) { adesao_institucional_id_ref = 0 }


        var dataPost = {

            regiao: regiao,
            uf: uf,

        }

        setCarregando('block')


        await api.post(`/residuosListaPendencias/${adesao_institucional_id_ref}/${ano}`, dataPost).then((result) => {

            //console.log(result.data)
            setTotalPreenchimentos(result.data.length)
            setResultadoPend(result.data)
            /*
            setResultadoPend(result.data.map((rs) => {
            
            
                return {

                    nome_fantasia: rs.nome_fantasia,
                    cnpj: rs.cnpj,
                    adesao_institucional_id: rs.adesao_institucional_id,
                    residuo_id: rs.residuo_id,
                    situacaoPerfilAnual: rotulo(rs.situacaoPerfilAnual),
                    secaoGestao: rotulo(rs.secaoGestao),
                    secaoGeracao: rotulo(rs.secaoGeracao),
                    dataEnvio: rs.dataEnvio,
                    situacaoEnviado: rotuloEnviado(rs.situacaoEnviado),
                    dataEnvio: rs.dataEnvio,
                    dataUltimoPreenchimento: rs.dataUltimoPreenchimento,
                    anoDesafio: rs.anoDesafio,
                    anoPerfil: rs.anoPerfil,
                    dataAdesaoResiduos: rs.dataAdesaoResiduos,
                    //clickEvent: () => { setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio); setAdesaoInstitucionalId(rs.adesao_institucional_id); setResiduo_id(rs.residuo_id); window.$("#modalResiduos").modal('show');}
                    
                }

            }))
            */

            setCarregando('none')

        }).catch((err) => {

            console.log(err)
            setCarregando('none')

        })


    }


    /*
    async function geraExcel() {

        window.toastr.success('Aguarde, gerando XLSX...')

        await api.get('geraExcelResiduos/0').then((result) => {

            if (result.data.alerta == 'ok') {

                sleep(1000).then(() => {

                    //window.location.href = `http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`
                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`

                })
            

            }

        }).catch((err) => {

            console.log(err.response)

        })

    }
    */


    const geraExcel = async () => {

        window.toastr.info("Aguarde...");

        try {

        const response = await api.get(`geraExcelResiduos/0`, {
            responseType: "blob",
            validateStatus: (status) => true // para não cair direto no catch
        });

        if (response.status !== 200) {
            // ler como texto para ver o erro real
            const errorText = await response.data.text();
            console.error("Erro backend:", errorText);
            window.toastr.error("Erro ao exportar: " + errorText);
            return;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "residuos.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        window.toastr.success("Download concluído!");
        } catch (err) {
        console.error(err);
        window.toastr.error("Falha ao baixar arquivo");
        }
    };




    /*

    async function geraExcelGeracao() {

        window.toastr.success('Aguarde, gerando XLSX...')

        await api.get('geraExcelResiduosGeracao').then((result) => {

            if (result.data.alerta == 'ok') {

                sleep(1000).then(() => {

                    //window.location.href = `http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`
                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`

                })
            

            }

        }).catch((err) => {

            console.log(err.response)

        })

    }

    */



    const geraExcelGeracao = async () => {

        window.toastr.info("Aguarde...");

        try {

        const response = await api.get(`geraExcelResiduosGeracao`, {
            responseType: "blob",
            validateStatus: (status) => true // para não cair direto no catch
        });

        if (response.status !== 200) {
            // ler como texto para ver o erro real
            const errorText = await response.data.text();
            console.error("Erro backend:", errorText);
            window.toastr.error("Erro ao exportar: " + errorText);
            return;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "residuosGeracao.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        window.toastr.success("Download concluído!");
        } catch (err) {
        console.error(err);
        window.toastr.error("Falha ao baixar arquivo");
        }
    };





    

    
    /*

    function geraExcelPend() {

        window.toastr.success('Aguarde, gerando XLSX...')

         api.get(`geraExcelResiduosPend/${adesao_institucional_id_ref}/${ano}`).then((result) => {

            //console.log(result.data)
            //return false

            if (result.data.alerta == 'ok') {

                sleep(1000).then(() => {

                    //window.location.href = `http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`
                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`

                })

                
            }

        }).catch((err) => {

            console.log(err.response)

        })

    }

    */

    const geraExcelPend = async () => {

        window.toastr.info("Aguarde...");

        try {

        const response = await api.get(`geraExcelResiduosPend/${adesao_institucional_id_ref}/${ano}`, {
            responseType: "blob",
            validateStatus: (status) => true // para não cair direto no catch
        });

        if (response.status !== 200) {
            // ler como texto para ver o erro real
            const errorText = await response.data.text();
            console.error("Erro backend:", errorText);
            window.toastr.error("Erro ao exportar: " + errorText);
            return;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "residuos.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        window.toastr.success("Download concluído!");
        } catch (err) {
        console.error(err);
        window.toastr.error("Falha ao baixar arquivo");
        }
    };


    
    const geraExcelGeracaoMensal = async () => {

        window.toastr.info("Aguarde...");

        try {

        const response = await api.get(`extracaoGeracaoResiduosMensalXLS`, {
            responseType: "blob",
            validateStatus: (status) => true // para não cair direto no catch
        });

        if (response.status !== 200) {
            // ler como texto para ver o erro real
            const errorText = await response.data.text();
            console.error("Erro backend:", errorText);
            window.toastr.error("Erro ao exportar: " + errorText);
            return;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "residuosGeracao.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        window.toastr.success("Download concluído!");
        } catch (err) {
        console.error(err);
        window.toastr.error("Falha ao baixar arquivo");
        }
    };


    




    const correcoes = () => {

        var dataPost = {

            desafio: 'Resíduos'

        }

        api.post('desafioValidaCorrecoes', dataPost).then((result) => {

            setResultadoCorrecoes(result.data)
            setTotalCorrecoes(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })


    }


    const carregaRegiao = () => {

        api.get('regiao').then((result) => {

            setResultadoRegiao(result.data.map((rs) =>
                    
                <option value={rs.regiao}>{rs.regiao}</option>
        
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    const carregaUF = () => {

        api.get('uf').then((result) => {

            //console.log(result.data)

            setResultadoUF(result.data.map((rs) =>
                    
                <option value={rs.uf_codigo}>{rs.uf_codigo}</option>
        
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    const verificados = () => {

        var dataPost = {

            desafio: 'Resíduos'

        }

        api.post('desafioValidaVerificados', dataPost).then((result) => {

            console.log(result.data, 'verificados')

            setResultadoVerificados(result.data)
            setTotalVerificados(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })


    }


    const abreCertificado = async (dataPost) => {

        

        api.post('certificado', dataPost).then((result) => {

            window.toastr.info('Aguarde...')
            
            if (result.data.arquivo) {

                sleep(1000).then(() => {

                    window.open(`${process.env.REACT_APP_API}/pdf/${result.data.arquivo}`)

                })

            }

        }).catch((err) => {

            console.log(err.response)

        })

    }


    const columnsVerificados = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoDesafio',
            header: 'Ano',
          },

          {
            accessorKey: 'certificacao',
            header: 'Reconhecimento',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: corCertificado(renderedCellValue) }}>{renderedCellValue}</Badge>
           
            ),
          },
         

        ],
        [],
      );

    useEffect(() => {

        carregaRegiao()
        carregaUF()
        //residuosLista()
        carregaRede()
        carregaAnos()
        preenchimentos()
        residuosLista()

    }, [])

    useEffect(() => {

        //console.log(ano)
        preenchimentos(adesao_institucional_id_ref)
        correcoes()
        verificados()

    }, [ano, regiao, uf, verificaDesafio])


    return (

        <div>
             <div className='content-header'>
                <div className='header-icon'>
                    <i className='pe-7s-trash'></i>
                </div>
                <div className='header-title'>
                    <h1>Resíduos SS</h1>
                    <small>Administração</small>
                    
                </div>

            </div>

            <ul className="nav nav-tabs">
            
                <li ><a href="#tab1" data-toggle="tab" >Adesões ({totalAdesoes})</a></li>
                <li className="active"><a href="#tab2" data-toggle="tab" onClick={() => preenchimentos()} >Preenchimentos ({totalPreenchimentos})</a></li>
                <li><a href="#tab3" data-toggle="tab" >Correções ({totalCorrecoes})</a></li>
                <li><a href="#tab4" data-toggle="tab" >Verificados ({totalVerificados})</a></li>
                
                
                
            </ul>

            <div class="tab-content">
                    <div class="tab-pane fade in" id="tab1">
                        <div class="panel-body">


                            <div class="col-md-12">


                                <button type="button" class="btn btn-success" onClick={() => geraExcel()}>Exportar XLS Dados Gestão</button>&nbsp;
                                <button type="button" class="btn btn-info" onClick={() => geraExcelGeracao()}>Exportar XLS Dados Geração</button>&nbsp;
                                <br/><br/>


                            </div>


                                


                                    <div className="col-sm-12"  style={{ display: resultado ? 'block' : 'none'}}>
                                        
                                            
                                                
                                                <div className="table-responsive">
                                                   
                                                        <MaterialReactTable 

                                                            columns={columnsR} 
                                                            data={resultado} 
                                                            localization={MRT_Localization_PT_BR}
                                                            //rowsPerPage={20}
                                                            //options={options}
                                                            initialState={{ density: 'compact' }}
                                                            muiTableHeadCellProps={{
                                                                //easier way to create media queries, no useMediaQuery hook needed.
                                                                sx: {
                                                                fontSize: {
                                                                    xs: '8px',
                                                                    sm: '9px',
                                                                    md: '10px',
                                                                    lg: '11px',
                                                                    xl: '12px',
                                                                },
                                                                },
                                                            }}
                                                            muiTableBodyCellProps={{
                                                                sx: {
                                                                    fontSize: {
                                                                    xs: '8px',
                                                                    sm: '9px',
                                                                    md: '10px',
                                                                    lg: '11px',
                                                                    xl: '12px',
                                                                    },
                                                                },
                                                            }}
                                                            muiTableBodyRowProps={({ row }) => ({
                                                            onClick: (event) => {
                                                                //console.info(event, row.original.usuario_id);
                                                                history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                                                //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                                                //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                                                //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                                                //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setHospClima_id(row.original.hospClima_id); window.$("#modalDesafioClima").modal('show')

                                                            },
                                                            sx: {
                                                                cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                                            },
                                                            })}
                                                        />
                                                </div>
                                            
                                        
                                    
                                </div>


                        </div>
                        </div>
                        <div className="tab-pane fade in active" id="tab2">
                            
                            <div class="panel-body">

                                <div class="col-md-12">


                                    <button type="button" class="btn btn-success" onClick={() => geraExcelPend()}>Exportar XLS</button>&nbsp;
                                    <button type="button" class="btn btn-success" onClick={() => geraExcelGeracaoMensal()}>Exportar XLS Geração Mensal</button>&nbsp;
                                    <br/>


                                </div>

                                <div className="col-md-12">
                                    <div className="form-group">

                                        <br/>
                                        
                                        <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {preenchimentos(event.target.value);setAdesaoInstitucionalIdRef(event.target.value)}} value={adesao_institucional_id_ref} >
                                            <option value="0">[Rede ou Sistema de Saúde]</option>
                                            {resultadoRede}
                                        </select>  
                                        
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-group">

                                        
                                        
                                        <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setAno(event.target.value)}} value={ano} >
                                            <option value={0}>Todos os anos</option>
                                            {anos}
                                        </select>  
                                        
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">

                                        
                                        <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setUF(event.target.value)}} value={uf} >
                                            <option value="">[UF]</option>
                                            {resultadoUF}
                                        </select>  
                                        
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">

                                        
                                        <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setRegiao(event.target.value)}} value={regiao} >
                                            <option value="">[Região]</option>
                                            {resultadoRegiao}
                                        </select>  
                                        
                                    </div>
                                </div>

                                <div className="col-md-12" style={{ display: carregando }} >
                                <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                                </div>


                                <div className="col-md-12" style={{ display: carregando == 'none' ? 'block' : 'none'}}>


                                        <MaterialReactTable 
                                        
                                        columns={columns} 
                                        data={resultadoPend} 
                                        localization={MRT_Localization_PT_BR}
                                        //rowsPerPage={20}
                                        //options={options}
                                        initialState={{ density: 'compact' }}
                                        muiTableHeadCellProps={{
                                            //easier way to create media queries, no useMediaQuery hook needed.
                                            sx: {
                                            fontSize: {
                                                xs: '8px',
                                                sm: '9px',
                                                md: '10px',
                                                lg: '11px',
                                                xl: '12px',
                                            },
                                            },
                                        }}
                                        muiTableBodyCellProps={{
                                            sx: {
                                                fontSize: {
                                                xs: '8px',
                                                sm: '9px',
                                                md: '10px',
                                                lg: '11px',
                                                xl: '12px',
                                                },
                                            },
                                        }}
                                        muiTableBodyRowProps={({ row }) => ({
                                        onClick: (event) => {
                                            //console.info(event, row.original.usuario_id);
                                            //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                            //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                            //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                            setAnoProps(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                    
                                        },
                                        sx: {
                                            cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                        },
                                        })}
                                    />

                                </div>

        

                            </div>


                        </div>
                        <div className="tab-pane fade in" id="tab4">

                            <div className="panel-body">

                                <div className="col-md-12" style={{ display: carregando }} >    
                                  <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                                </div>
                            
                              <div className="col-md-12" style={{ display: resultadoVerificados ? 'block' : 'none'}}>

                                    <MaterialReactTable 

                                        columns={columnsVerificados} 
                                        data={resultadoVerificados} 
                                        localization={MRT_Localization_PT_BR}
                                        //rowsPerPage={20}
                                        //options={options}
                                        initialState={{ density: 'compact' }}
                                        muiTableHeadCellProps={{
                                            //easier way to create media queries, no useMediaQuery hook needed.
                                            sx: {
                                            fontSize: {
                                                xs: '8px',
                                                sm: '9px',
                                                md: '10px',
                                                lg: '11px',
                                                xl: '12px',
                                            },
                                            },
                                        }}
                                        muiTableBodyCellProps={{
                                            sx: {
                                                fontSize: {
                                                xs: '8px',
                                                sm: '9px',
                                                md: '10px',
                                                lg: '11px',
                                                xl: '12px',
                                                },
                                            },
                                        }}
                                        muiTableBodyRowProps={({ row }) => ({
                                        onClick: (event) => {
                                            
                                            //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); 
                                            //setHospClima_id(row.original.hospClima_id); window.$("#modalCertificado").modal('show')

                                            abreCertificado({

                                                ano: row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio,
                                                adesao_institucional_id: row.original.adesao_institucional_id,
                                                formulario_id: row.original.residuo_id,
                                                certificacao: row.original.certificacao,
                                                origem: 'Resíduos',

                                            })

                                        },
                                        sx: {
                                            cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                        },
                                        })}

                                    />


                                </div>

                            </div>

                        </div>
                        <div className="tab-pane fade in" id="tab3">

                            <div class="panel-body">

                            <div className="col-md-12" style={{ display: carregando }} >
                                <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                            </div>
                        
                            <div className="col-md-12" style={{ display: resultadoCorrecoes ? 'block' : 'none'}}>


                                    <MaterialReactTable 

                                    columns={columnsCorrecoes} 
                                    data={resultadoCorrecoes} 
                                    localization={MRT_Localization_PT_BR}
                                    //rowsPerPage={20}
                                    //options={options}
                                    initialState={{ density: 'compact' }}
                                    muiTableHeadCellProps={{
                                        //easier way to create media queries, no useMediaQuery hook needed.
                                        sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                        },
                                    }}
                                    muiTableBodyCellProps={{
                                        sx: {
                                            fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                            },
                                        },
                                    }}
                                    muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        //console.info(event, row.original.usuario_id);
                                        //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                        //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                        //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                        //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                        setAnoProps(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                    },
                                    sx: {
                                        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                    })}
                                    />

                                </div>

                            </div>

                        </div>

            </div>

            

            
            <ModalResiduo adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={residuo_id} residuo_id={residuo_id} />
            <ModalValidacao adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={residuo_id} origem='Resíduos' correcoes={correcoes} />
            <ModalEmailCorrecao adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={residuo_id} origem='Resíduos' correcoes={correcoes} />
            <ModalEmailVer desafioEmail_id={desafioEmail_id}  />

        </div>

    )

}

export default Residuos